/*global _moovilaSecurity */
/*eslint no-undef: "error"*/
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import momApp from './';

let composition;
let initialState = {};

if (process.env.NODE_ENV !== 'test') {
  if (_moovilaSecurity.CurrentSession()) {
    initialState = {loggedIn: _moovilaSecurity.CurrentSession().SessionInfo || { isLoggedIn: false }};
  }
}

if (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  composition = compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
} else {
  composition = applyMiddleware(thunk);
}

let store = createStore(
  momApp,
  initialState,
  composition
);

export default store;



// WEBPACK FOOTER //
// ./src/reducers/_store.js